// Module
var code = "<h2 id=\"are-your-loans-delinquent\">Are Your Loans Delinquent?</h2> <p>Learn how to resolve the delinquency on your loan before it defaults. </p> ";
// Exports
export default code;